import { SITE_URL } from "@/lib/config/env-var.config";

export const getCreatorSlugUrl = (creatorSlug: string) =>
  `${SITE_URL}/@${creatorSlug}`;

export const getAlbumSlugUrl = (creatorSlug: string, albumSlug: string) =>
  `${getCreatorSlugUrl(creatorSlug)}/${albumSlug}`;

/** Matches the album slug column, VarChar(100). */
export const MAX_ALBUM_SLUG = 100;

const SLUG_PATTERN = /^[a-zA-Z0-9_]+(?:-[a-zA-Z0-9_]+)*$/;
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Mirrors the API's `validateSlug` so a malformed slug is caught before the
 * save. An empty slug is valid — it asks for the title-derived default.
 */
export const getAlbumSlugError = (slug: string): string | null => {
  const trimmed = slug.trim();
  if (!trimmed) return null;
  if (trimmed.length > MAX_ALBUM_SLUG)
    return `Keep the custom URL to ${MAX_ALBUM_SLUG} characters or fewer`;
  if (!SLUG_PATTERN.test(trimmed))
    return "Letters, numbers, dashes and underscores only, and it can't start or end with a dash";
  if (UUID_PATTERN.test(trimmed)) return "The custom URL can't be a UUID";
  return null;
};
